export default __webpack_public_path__ + "static/media/feel-good.cc9f1d08.svg";